"use strict";
// artifact functions
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createArtifactUtils = void 0;
const common_1 = require("@finley-technologies/common");
const dbNodes = __importStar(require("../dbNodes/dbNodes"));
const createArtifactUtils = (basicGraph, params) => {
    const prefix = `[${params.borrowerSlug}][artifactDocumentId:${params.id}]`;
    const _isLeafNode = (artifactId) => {
        return basicGraph.getInputs(artifactId).length === 0;
    };
    // return all raw inputs required for given artifactId.
    const _getLeafInputs = (artifactId) => {
        const rawInputs = basicGraph
            .getRecursiveInputs(artifactId)
            .filter(_isLeafNode)
            .map(basicGraph.getArtifactById);
        return rawInputs;
    };
    const _getGeneratedLoanTapeArtifacts = ({ loanProductSlug, }) => {
        const generatedLoanTapes = params.artifacts
            .filter((node) => dbNodes.generatedLoanTape.isNode(node))
            .filter(({ loanProductSlug: slug }) => slug === loanProductSlug);
        (0, common_1.finleyAssert)(generatedLoanTapes.length >= 0, `${prefix}: no generatedLoanTape found matching [loanProductSlug:${loanProductSlug}]`);
        return generatedLoanTapes;
    };
    return {
        _getLeafInputs,
        _getGeneratedLoanTapeArtifacts,
    };
};
exports.createArtifactUtils = createArtifactUtils;
//# sourceMappingURL=artifacts.js.map